"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apaParamsLoader = void 0;
var namespace_1 = __importDefault(require("../namespace"));
exports.apaParamsLoader = {
    loader: {
        'default': {
            dataType: 'jsonp',
            cache: false,
            async: true,
            crossDomain: false,
            timeout: 60000,
            type: 'GET',
            url: '',
            hasProgress: false
        },
        'items': {
            dataType: 'script',
            cache: true,
            async: true,
            crossDomain: true,
            timeout: 60000,
            type: 'GET',
            url: '',
            hasProgress: false
        },
        'language': {
            dataType: 'jsonp',
            cache: true,
            async: true,
            crossDomain: true,
            timeout: 30000,
            type: 'GET',
            url: '',
            hasProgress: false
        },
        'scripts': {
            dataType: 'script',
            cache: true,
            async: true,
            crossDomain: true,
            timeout: 60000,
            type: 'GET',
            url: '',
            hasProgress: false
        },
        'configs': {
            dataType: 'jsonp',
            cache: true,
            async: true,
            crossDomain: true,
            timeout: 60000,
            type: 'GET',
            url: '',
            hasProgress: false
        }
    }
};
namespace_1.default.namespace.extend('params', exports.apaParamsLoader);
